import countdown from "../countdown"
import exitIntentPopup from "../exitIntentPopup"
import primer from "../primer"

export default (getView) => (nextStepPath, timeoutSeconds, popupStepPath, externalCheckoutPath) => ({
  ...getView(nextStepPath),
  ...countdown(timeoutSeconds),
  ...primer(),
  ...exitIntentPopup(popupStepPath),

  statusToTrack: "VISIT_CHECKOUT",

  async onInit() {
    const externalCheckout = pipelineConfig.variant.includes("External-Checkout")

    this.initCountdown()
    this.store.restorePurchasedBasicOffer()

    if (
      this.store.values.exitIntent &&
      new URLSearchParams(window.location.hash.substr(1)).has("token")
    ) {
      this.store.values.exitIntent = false
      await this.store.push()
    }

    if (!externalCheckout) {
      this.addConfirmationEventListener()
      this.initPrimer({
        checkoutCompletePath: nextStepPath,
      })
    }

    if (popupStepPath) this.initExitIntentPopup()
  },

  goToExternalPaymode(hideApm = false) {
    this.store.values.hideApm = hideApm
    window.location = this.store.addTokenHashParam(externalCheckoutPath)
  },
})
